import { Component, forwardRef, Input, ElementRef, ViewChild } from "@angular/core";
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from "@angular/forms";
import { Temperature } from "shared/cubiq-services";
import { MenuItem } from "@bfx/primeng/api";
import { BfxBlotterFilterable } from "./bfx-blotter-filterable";
import { SplitButton } from "@bfx/primeng/splitbutton";

export const STATEFILTER_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => BfxBlotterFilterStateComponent),
  multi: true,
};

@Component({
  selector: "bfx-blotter-filter-state",
  templateUrl: "./html/bfx-blotter-filter-state.html",
  providers: [STATEFILTER_VALUE_ACCESSOR],
  standalone: false,
})
export class BfxBlotterFilterStateComponent implements ControlValueAccessor {
  /**
   * Optional blotter instance or any implementor of blotter filterable
   */
  @Input()
  public blotterInstance: BfxBlotterFilterable = null;

  private value: string = null;

  private onModelChange: Function = () => {};
  private onModelTouched: Function = () => {};

  private disabled: boolean = false;

  public activeItem: string = null;
  public activeIcon: string = null;

  styleClasses: any = {};

  public items: Array<MenuItem> = [];

  @ViewChild("splitOptions")
  private splitOptions: SplitButton;

  constructor(private button: ElementRef) {
    this.updateStyleClasses();
  }

  /**
   * Initialize value from blotter configuration in case this component is attached to
   * blotter filter bar.
   */
  ngOnInit() {
    if (this.blotterInstance != null) {
      this.items = this.blotterInstance.getStateFilters().map((value) => {
        return {
          label: value,
          command: () => {
            // this.setValueInternal(value);
          },
        };
      });
      this.value = this.blotterInstance.getDefaultStateFilter();
      this.updateActiveItem();
    }
  }

  protected updateActiveItem() {
    let activeItem = this.items.find((o) => o.label === this.value);
    this.activeItem = activeItem?.label;
    this.activeIcon = activeItem?.icon;
  }

  protected updateStyleClasses(): void {
    this.updateActiveItem();
  }

  protected setFilterState(value: string) {
    this.value = value;
    this.onModelChange(value);
    this.updateStyleClasses();

    if (this.blotterInstance != null) {
      this.blotterInstance.stateFilterChanged(value);
    }
  }

  writeValue(value: any): void {
    this.value = value;
    this.updateStyleClasses();
  }

  registerOnChange(fn: Function): void {
    this.onModelChange = fn;
  }

  registerOnTouched(fn: Function): void {
    this.onModelTouched = fn;
  }

  setDisabledState(val: boolean): void {
    this.disabled = val;
  }
}
